import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var WorktopView = /** @class */ (function (_super) {
    tslib_1.__extends(WorktopView, _super);
    function WorktopView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    WorktopView.prototype.mounted = function () {
        this.$state.mode = "worktop";
    };
    WorktopView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    Object.defineProperty(WorktopView.prototype, "dimensionsFilled", {
        get: function () {
            var dimensions = [this.$state.worktopLength, this.$state.worktopHeight, this.$state.worktopWidth];
            return dimensions.filter(function (d) { return d; }).length == dimensions.length;
        },
        enumerable: true,
        configurable: true
    });
    WorktopView = tslib_1.__decorate([
        Component
    ], WorktopView);
    return WorktopView;
}(Vue));
export default WorktopView;
